import { UserAPI } from "../Endpoints";

class Auth {
    login(user, password) {
        return UserAPI.post("/login", {
            username: user,
            password: password
        });
    }

    refreshToken() {
        return UserAPI.refreshToken();
    }

    sendResetPasswordMail(email) {
        return UserAPI.post("/forgotpassword", { email: email });
    }

    setNewPassword(token, password) {
        return UserAPI.post("/changepassword", {
            token: token,
            password: password
        });
    }

    changePassword(password, oldpassword) {
        return UserAPI.post("/changepassword", {
            password: password,
            oldpassword: oldpassword
        });
    }
}

export default new Auth();
